export const PAGE_BACKGROUND = "bg-[#f3eddb]";
export const PANEL_CLASS = "border-2 border-black bg-[#BCB7A8]";
export const CARD_CLASS = "border-2 border-black bg-[#BCB7A8]";
export const BUTTON_MUTED =
  "border-2 border-black bg-[#BCB7A8] px-2 py-1 text-xs font-semibold text-black transition-colors hover:bg-[#a19881]";
export const BUTTON_PRIMARY =
  "border-2 border-black bg-black px-4 py-3 text-sm font-semibold text-[#F3F0E6] transition-colors hover:bg-[#2d2d2d]";
export const BUTTON_ALERT =
  "border-2 border-black bg-[#d26767] px-4 py-2 text-sm font-semibold text-[#FDF7EC] transition-colors hover:bg-[#b95555]";
